/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {CurrencyCodeType} from 'shared/web';

export const CURRENCY_CZK = 'CZK' as CurrencyCodeType;
export const CURRENCY_EUR = 'EUR' as CurrencyCodeType;
export const DEFAULT_CURRENCY = CURRENCY_CZK;
export const DEFAULT_FOREIGN_CURRENCY = CURRENCY_EUR;
